import React, { useEffect, useState } from "react";
import { fireDB } from "../../firebase/FirebaseConfig";
import { collection, getDocs } from "firebase/firestore";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./Blogs.css";

const Blogs = () => {
    const [blogs, setBlogs] = useState([]);

    const getBlogs = async () => {
        const snap = await getDocs(collection(fireDB, "blogs"));
        const blogList = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setBlogs(blogList);
    };

    useEffect(() => {
        getBlogs();
    }, []);

    return (
        <Container className="my-5">
            <h2 className="text-center mb-4 fw-bold">📝 Travel Blogs</h2>

            <Row>
                {blogs.length > 0 ? (
                    blogs.map((blog) => (
                        <Col md={3} sm={6} xs={6} className="mb-4" key={blog.id}>
                            <Link
                                to={`/blog/${blog.id}`}
                                className="text-decoration-none text-dark"
                            >
                                <Card className="shadow-sm rounded-4 border-0 blog-card">
                                    <Card.Img
                                        variant="top"
                                        src={blog.thumbnail}
                                        className="rounded-top-4"
                                        style={{
                                            height: "210px",
                                            objectFit: "cover",
                                        }}
                                    />

                                    <Card.Body className="d-flex flex-column">

                                        {/* TITLE */}
                                        <Card.Title className="fw-bold blog-title">
                                            {blog.title?.substring(0, 50)}...
                                        </Card.Title>

                                        {/* DESCRIPTION */}
                                        <Card.Text className="text-muted blog-desc">
                                            {blog.shortDesc}
                                        </Card.Text>

                                        {/* DATE */}
                                        <div className="mt-auto">
                                            <small className="text-secondary">
                                                📅{" "}
                                                {blog.date
                                                    ? blog.date.toDate().toLocaleDateString()
                                                    : "No Date"}
                                            </small>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                    ))
                ) : (
                    <p className="text-center mt-4">No blogs available.</p>
                )}
            </Row>
        </Container>
    );
};

export default Blogs;
